export default __webpack_public_path__ + "static/banner-76dc3a98aa102a6f5c0c1bed0345b63e.png";